module.exports = __webpack_public_path__ + "img/sjtj_1.6d13da24.svg";